import * as crossWindowEvents from "Shared/cross-window-events";
import deepmerge from "deepmerge";
import * as server from "Shared/server";
import { batchActions } from "redux-batched-actions";
import { updateODPTracking, ODPTrackingActions, sendToPeerius, addEcommerceEventToDataLayer, } from "./../TrackingInformation";
import currentPageIsCheckout from "./../../Features/Checkout/Pages/Checkout/current-page-is-checkout";
import { setFeedback } from "SiteLayout/GenericFeedbackBar/action-creators";
import { translate } from "Shared/translate";
import { updateCartItemQuantity } from "../Checkout/action-creators";
import { isProductPage } from "../../Features/Product/Commerce/current-page-is-product";
export const CART_LOAD = "CART_LOAD";
export const CART_LOAD_SUCCESS = "CART_LOAD_SUCCESS";
export const CART_LOAD_FAILURE = "CART_LOAD_FAILURE";
export const CART_INVALID_QUANTITY = "CART_INVALID_QUANTITY";
export const CART_OPTIMISTIC_UPDATE = "CART_OPTIMISTIC_UPDATE";
export const CART_CHANGES_ACCEPTED = "CART_CHANGES_ACCEPTED";
export const TOGGLE_IGNORE_AVAILABILITY = "TOGGLE_IGNORE_AVAILABILITY";
export function getExistingItem(cart, code) {
    if (!code) {
        return;
    }
    const existingCartItem = cart.items.find((i) => i.lineItem.code === code);
    return existingCartItem && existingCartItem.lineItem;
}
export function rejectInvalidQuantity(code) {
    return (dispatch) => {
        dispatch({
            type: CART_INVALID_QUANTITY,
            code,
        });
        return Promise.reject(null);
    };
}
export const isValidQuantity = (quantity, limit) => {
    if (isNaN(quantity)) {
        return false;
    }
    if (!isNaN(limit) && quantity > limit) {
        return false;
    }
    if (quantity < 0) {
        return false;
    }
    return true;
};
const getCurrentPageCartLocation = (state) => {
    if (state.quickSearch.isOpen)
        return "QuickSearch";
    const componentName = state.currentPage.componentName || "";
    if (componentName.includes("CampaignOverviewPageViewModel") || componentName.includes("CampaignPageViewModel"))
        return "CampaignPage";
    if (componentName.includes("CategoryViewModel"))
        return "CategoryPage";
    if (componentName.includes("SearchPageViewModel"))
        return "SearchPage";
    if (componentName.includes("ProductViewModel"))
        return "ProductPage";
    return "ProductList";
};
export const addToCart = (code, quantity, unitShortName, ticket = null, location = null, experiment, ga4TrackingContext) => (dispatch, getState) => {
    var _a, _b;
    if (!isValidQuantity(quantity)) {
        rejectInvalidQuantity(code);
        return Promise.reject(null);
    }
    const cart = getState().cart;
    const existingItem = getExistingItem(cart, code);
    const newItemTicket = existingItem ? null : ticket;
    const isUpdateAction = existingItem ? true : false;
    const previousQuantity = existingItem ? existingItem.quantity : 0;
    updateODPTracking(code, ODPTrackingActions.ADD_TO_CART);
    const explicitLocation = !!location && location !== "ProductList";
    let resolvedLocation = explicitLocation ? location : getCurrentPageCartLocation(getState());
    if (!explicitLocation && currentPageIsCheckout(getState().currentPage)) {
        const cartCodes = ((_b = (_a = getState().cart) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map((i) => { var _a; return (_a = i.lineItem) === null || _a === void 0 ? void 0 : _a.code; }).filter(Boolean)) || [];
        resolvedLocation = cartCodes.includes(code) ? "CheckoutPage" : "RecommendationPanel";
    }
    else if (!explicitLocation && isProductPage(getState().currentPage)) {
        const selectedUnits = getState().product.selectedUnits || [];
        const currentPdpCode = selectedUnits.length
            ? String(selectedUnits[selectedUnits.length - 1])
            : null;
        resolvedLocation =
            currentPdpCode && code === currentPdpCode ? "ProductPage" : "RecommendationPanel";
    }
    if (currentPageIsCheckout(getState().currentPage)) {
        return dispatch(updateCartItemQuantity(code, quantity, null, unitShortName, resolvedLocation, newItemTicket, false, ga4TrackingContext));
    }
    return dispatch(sendCartRequest(() => {
        return {
            items: {
                [code]: {
                    isUpdateAction,
                    newQuantity: quantity,
                    newUnitShortName: unitShortName,
                    previousQuantity,
                    previousUnitShortName: unitShortName,
                },
            },
        };
    }, resolvedLocation, newItemTicket, experiment, ga4TrackingContext)).catch((e) => {
        dispatch(setFeedback({
            type: "error",
            text: translate("/Cart/Errors/ChangeQuantity"),
        }));
    });
};
export function updateCartItemUnit(code, unitShortName, location) {
    return (dispatch) => {
        return dispatch(sendCartRequest((cart) => {
            const existingItem = getExistingItem(cart, code);
            return {
                items: {
                    [code]: {
                        isUpdateAction: true,
                        newQuantity: existingItem.quantity,
                        newUnitShortName: unitShortName,
                        previousQuantity: existingItem.quantity,
                        previousUnitShortName: existingItem.selectedVariant.unitShortName,
                        rowNumber: existingItem.rowNumber,
                    },
                },
            };
        }, location)).catch((e) => {
            dispatch(setFeedback({
                type: "error",
                text: translate("/Cart/Errors/ChangeUnit"),
            }));
        });
    };
}
export function removeCartItem(code, location) {
    return (dispatch) => {
        return dispatch(sendCartRequest((cart) => {
            const existingItem = getExistingItem(cart, code);
            if (!existingItem || !existingItem.selectedVariant) {
                return null;
            }
            updateODPTracking(code, ODPTrackingActions.REMOVE_FROM_CART);
            return {
                items: {
                    [code]: {
                        newQuantity: 0,
                        newUnitShortName: existingItem.selectedVariant.unitShortName,
                        previousQuantity: existingItem.quantity,
                        previousUnitShortName: existingItem.selectedVariant.unitShortName,
                        deleteRowOverride: true,
                    },
                },
            };
        }, location)).catch((e) => {
            dispatch(setFeedback({ type: "error", text: translate("/Cart/Errors/Remove") }));
        });
    };
}
let currentCartUpdate = Promise.resolve(null);
crossWindowEvents.on(["cart-modified", "checkout-modified"], (store) => {
    if (!currentPageIsCheckout(store.getState().currentPage)) {
        doReloadCart(store.dispatch);
    }
    else {
        console.info("Ignoring cart changes on checkout page");
    }
});
export function reloadCart() {
    return doReloadCart;
}
function doReloadCart(dispatch) {
    dispatch({
        type: CART_LOAD,
    });
    const updateCart = () => {
        console.debug("Reloading cart since it was modified in another window/tab");
        const url = { path: "/cart" };
        server
            .get(url)
            .then((r) => r.json())
            .then((json) => {
            if (!!json.cartUpdatesPageTrackingData) {
                sendToPeerius(json.cartUpdatesPageTrackingData);
            }
            dispatch({
                type: CART_LOAD_SUCCESS,
                cart: json,
            });
        })
            .catch((e) => {
            console.error(e);
            dispatch({
                type: CART_LOAD_FAILURE,
                error: e,
                url,
            });
            return Promise.reject(e);
        });
    };
    currentCartUpdate = currentCartUpdate.then(updateCart, updateCart);
}
let pendingTickets = [];
function sendCartRequest(diffOrCreator, location, ticket = null, experiment, ga4TrackingContext) {
    if (ticket) {
        pendingTickets.push(ticket);
    }
    return (dispatch, getState) => {
        let diff;
        if (typeof diffOrCreator === "function") {
            diff = diffOrCreator(getState().cart);
        }
        else {
            diff = diffOrCreator;
        }
        if (!!diff) {
            diff.id = Math.random();
        }
        dispatch(batchActions([
            {
                type: CART_OPTIMISTIC_UPDATE,
                diff,
            },
            {
                type: CART_LOAD,
            },
        ]));
        const sendNextRequest = () => {
            const state = getState().cart;
            const currentPendingChanges = state.pendingChanges;
            if (!currentPendingChanges.length) {
                return Promise.resolve();
            }
            let totalDiff = {};
            currentPendingChanges.forEach(r => {
                totalDiff = deepmerge(totalDiff, r); //MergeQuantity
            });
            totalDiff.location = !!location && location !== "ProductList" ? location : getCurrentPageCartLocation(getState());
            if (!!ga4TrackingContext) {
                totalDiff.ga4TrackingContext = ga4TrackingContext;
            }
            let headers;
            if (pendingTickets.length) {
                const tickets = pendingTickets.join(",");
                pendingTickets = [];
                headers = {
                    [server.ESALES_TICKET_HEADER]: tickets,
                    [server.ESALES_ACTION_HEADER]: server.ESALES_ADD_TO_CART_ACTION,
                };
            }
            const url = {
                path: "/cart/update",
            };
            return server
                .post(url, totalDiff, headers)
                .then((r) => r.json())
                .then((json) => {
                if (!!json.cartUpdatesPageTrackingData) {
                    sendToPeerius(json.cartUpdatesPageTrackingData);
                }
                if (json.trackingData && json.trackingData.ga4EventObjects) {
                    let ga4Events = json.trackingData.ga4EventObjects;
                    if ("add_to_cart" in ga4Events) {
                        addEcommerceEventToDataLayer(ga4Events["add_to_cart"]);
                    }
                    if ("remove_from_cart" in ga4Events) {
                        addEcommerceEventToDataLayer(ga4Events["remove_from_cart"]);
                    }
                }
                dispatch(batchActions([
                    {
                        type: CART_CHANGES_ACCEPTED,
                        changes: currentPendingChanges,
                    },
                    {
                        type: CART_LOAD_SUCCESS,
                        cart: json,
                    },
                ]));
                crossWindowEvents.emit("cart-modified");
            })
                .catch((e) => {
                console.error(e);
                dispatch({
                    type: CART_LOAD_FAILURE,
                    error: e,
                    url,
                });
                return Promise.reject(e);
            });
        };
        currentCartUpdate = currentCartUpdate.then(sendNextRequest, sendNextRequest);
        return currentCartUpdate;
    };
}
// function MergeQuantity(currentDiff:  { items?:{[item: string]: Shop.ItemUpdateState}; id?: number; }, newDiff: CartDiffType ){
//   if(JSON.stringify(currentDiff) === '{}')
//   {
//     currentDiff.items = newDiff.items,
//     currentDiff.id = newDiff.id
//     return currentDiff
//   }
//   for(var key in newDiff.items){
//     if(key in currentDiff.items)
//     {
//       currentDiff.items[key].newQuantity = newDiff.items[key].newQuantity
//     }
//     else
//     {
//       currentDiff.items[key] = newDiff.items[key];
//     }
//   }
//   return currentDiff;
// }
export function toNumber(quantity) {
    return parseFloat((quantity || "").replace(",", "."));
}
